import { render } from "./EventAddress.vue?vue&type=template&id=138d69de&scoped=true"
import script from "./EventAddress.vue?vue&type=script&lang=js"
export * from "./EventAddress.vue?vue&type=script&lang=js"

import "./EventAddress.vue?vue&type=style&index=0&id=138d69de&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-138d69de"]])

export default __exports__